import type TauriDatabase from "@tauri-apps/plugin-sql";
import { type Database as BunDatabase } from "bun:sqlite";

import { sql } from "../SqlString";

/**
 * Fetches all records and all columns from a given table.
 * @param db The database connection (either Bun's SQLite or Tauri's SQL plugin)
 * @param tableName The name of the table to fetch records from
 * @returns An array of records, where each record is an object with column names as keys
 */
export async function runGetAllRecords(
	db: BunDatabase | TauriDatabase,
	tableName: string
): Promise<unknown[]> {
	const { statement } = sql`SELECT * FROM ${sql.id(tableName)}`;

	if ("prepare" in db) {
		// Tauri SQL plugin
		const rows = db.prepare(statement).all();
		return rows as unknown[];
	} else {
		// Bun SQLite
		const rows = await db.select(statement);
		return rows as unknown[];
	}
}
